import { connect } from 'react-redux';
import PaymentFailurePage from './PaymentFailurePage';

const mapsStateToProps = state => ({});

const mapsDispatchToProps = dispatch => ({

});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(PaymentFailurePage);
